import LocalizedStrings from "react-localization";

const strings = new LocalizedStrings({
  en: {
    home_label: "Home",
    services_label: "Services",
    projects_label: "Projects",
    clients_label: "Clients",
    social_label: "Social",
    about_label: "About",
    about_us_label: "About us",
    work_here_label: "Work Here!",
    team_label: "Team",
    contact_label: "Contact",
    privacy_policy_label: "Privacy policy",
    careers_label: "Careers",
    open_positions_label: "Open positions",
    hiring_process_label: "Hiring Process",
    work_culture_label: "Work culture",
    intern_with_us: "Intern With Us!",
    rebrand_label: `We've rebranded!`,
  },
});

export default strings;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/localization/index.js